/* =========================================================
	SITE-WIDE SCRIPTS

	- Slide Toggle (for mobile nav)
	- UIKit
========================================================= */

/* Slide Toggle (for mobile nav) ---------------- */
import "./includes/slideToggle";

let navElement = document.getElementById("nav-toggle-container");

// If it isn't "undefined" and it isn't "null", then it exists.
if(typeof(navElement) != "undefined" && navElement != null){
	let navButton = document.getElementById("nav-toggle");

	navButton.addEventListener("click", function(event) {
		document.querySelector("#navigation").slideToggle();

		if (navButton.getAttribute("aria-expanded") === "true") {
			navButton.setAttribute("aria-expanded", false);
		} else {
			navButton.setAttribute("aria-expanded", true);
		}
	});
}

/* UIKit ---------------- */
import UIkit from 'uikit';
